import { Breadcrumb, Card, Row, Layout, Col } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import { Link, useRouteMatch, useHistory, useLocation } from 'react-router-dom'
import { getAppViewFromId } from 'Services/WeaverUtils'
import qs from 'qs'
import ConfigQuery from 'Model/ConfigQuery'
import CreateViewForm from './CreateViewForm'
import { useQuery } from 'Hooks'
import './index.scss'
import ViewTypeChoice from './ViewTypeChoice'
import * as viewTypes from './ViewTypes'


Views = ->
  { params: { spaceId, viewId }} = useRouteMatch()
  { search } = useLocation()
  [query, setQuery] = useState(undefined)
  [loading, setLoading] = useState(true)
  [viewType, setViewType] = useState(undefined)

  useEffect( ->
    (->
      qparams = qs.parse(search, { ignoreQueryPrefix: true })
      if viewId isnt 'new'
        { constructor: { className } } = await getAppViewFromId(viewId)
        setViewType(viewTypes[_.snakeCase(className).toUpperCase()])
      else
        setViewType(viewTypes[_.snakeCase(qparams.viewType).toUpperCase()])
      setQuery({
        query: qparams.query,
        queryType: qparams.queryType,
        fieldName: 'query'
      })
      setLoading(false)
    )()
    undefined
  , [])

  <Layout className="views-container">
    <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
      <Breadcrumb.Item>
        { Weaver.getInstance().currentProject().name() }
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to="/#{ spaceId }/settings/views">
          Views
        </Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        { viewId }
      </Breadcrumb.Item>
    </Breadcrumb>
    <Row style={{ flex: 1 }} justify="center" align="middle">
      <Col flex={0.6}>
        <Card
          loading={loading}
          className="create-view-container"
          bordered={false}
        >
          {
            unless viewType?
              <ViewTypeChoice setViewType={setViewType} />
            else
              <CreateViewForm
                viewType={viewType}
                setViewType={setViewType}
                query={query}
              />
          }
        </Card>
      </Col>
    </Row>
  </Layout>

export default Views
